import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "container flex-row-fluid" }
const _hoisted_3 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_4 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_5 = { class: "card mb-5 mb-xl-8 sticky-md-top" }
const _hoisted_6 = { class: "card-body pt-15" }
const _hoisted_7 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_8 = { class: "symbol symbol-100px symbol-circle mb-7" }
const _hoisted_9 = { class: "fs-3 text-gray-800 fw-bold mb-1" }
const _hoisted_10 = { class: "fs-3 text-gray-800 fw-bold mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded py-3 px-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold text-gray-700" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "w-75px" }, "6,900"),
      /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-arrow-up fs-3 text-success" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold text-muted" }, "Earnings")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded py-3 px-3 mx-4 mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold text-gray-700" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "w-50px" }, "130"),
      /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-arrow-down fs-3 text-danger" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold text-muted" }, "Tasks")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded py-3 px-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold text-gray-700" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "w-50px" }, "500"),
      /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-arrow-up fs-3 text-success" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold text-muted" }, "Hours")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_13 = { class: "py-5 fs-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mt-5" }, "ID Registro", -1)
const _hoisted_15 = { class: "text-gray-600" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mt-5" }, "Email", -1)
const _hoisted_17 = { class: "text-gray-600" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mt-5" }, "Celular", -1)
const _hoisted_19 = { class: "text-gray-600" }
const _hoisted_20 = { class: "flex-lg-row-fluid ms-lg-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_sPerson = _resolveComponent("sPerson")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_PhotoManager = _resolveComponent("PhotoManager")!
  const _component_TableHistory = _resolveComponent("TableHistory")!
  const _component_Sanctions = _resolveComponent("Sanctions")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialog_details,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog_details) = $event)),
    fullscreen: true,
    class: "dialog-person bg-light",
    onOpened: _ctx.onOpened,
    "close-on-click-modal": true,
    "close-on-press-escape": true,
    onClosed: _ctx.onClosed
  }, {
    header: _withCtx(({ titleId, titleClass }) => [
      _createElementVNode("h4", {
        id: titleId,
        class: _normalizeClass(titleClass)
      }, "Perfil del participante", 10, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createVNode(_component_el_avatar, {
                      shape: "circle",
                      size: "large",
                      class: _normalizeClass(`border border-3 border-${_ctx.gblPersona.status_class} shadow`),
                      style: {"width":"110px","height":"110px"},
                      fit: "fit",
                      src: `${_ctx.url}/uploads/${_ctx.photo.ruta}`
                    }, null, 8, ["class", "src"]), [
                      [_directive_loading, _ctx.loaderPhoto]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.gblPersona.firstname), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.gblPersona.lastname) + " " + _toDisplayString(_ctx.gblPersona.surname), 1),
                  _hoisted_11
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.gblPersona.idperson), 1),
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.gblPersona.email1), 1),
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.gblPersona.phone1), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.activeOption,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeOption) = $event)),
              "tab-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "Perfil",
                  name: "profile"
                }, {
                  default: _withCtx(() => [
                    (_ctx.activeOption == 'profile')
                      ? (_openBlock(), _createBlock(_component_sPerson, {
                          key: 0,
                          idperson: _ctx.gblPersona.idperson
                        }, null, 8, ["idperson"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Foto",
                  name: "photo"
                }, {
                  default: _withCtx(() => [
                    (_ctx.activeOption == 'photo')
                      ? (_openBlock(), _createBlock(_component_PhotoManager, {
                          key: 0,
                          idperson: _ctx.gblPersona.idperson
                        }, null, 8, ["idperson"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Historial",
                  name: "history"
                }, {
                  default: _withCtx(() => [
                    (_ctx.activeOption == 'history')
                      ? (_openBlock(), _createBlock(_component_TableHistory, {
                          key: 0,
                          idperson: _ctx.gblPersona.idperson
                        }, null, 8, ["idperson"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Sanciones",
                  name: "sanctions"
                }, {
                  default: _withCtx(() => [
                    (_ctx.activeOption == 'sanctions')
                      ? (_openBlock(), _createBlock(_component_Sanctions, {
                          key: 0,
                          idperson: _ctx.gblPersona.idperson
                        }, null, 8, ["idperson"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}